<template>
  <crud-modal
    :title="headerText || $t('modals.confirmDialog.defaultTitle')"
    :action="action"
    :on-submit="handleConfirm"
    :on-close="() => $emit('close')"
  >
    <div class="text-gray-700">
      {{ message }}
    </div>
  </crud-modal>
</template>

<script>
import CrudModal, { ACTIONS } from '@/components/modals/crud-modal.vue'

export default {
  components: {
    CrudModal
  },
  props: {
    message: {
      type: String,
      required: true
    },
    headerText: {
      type: String,
      required: false,
      default: null
    },
    action: {
      type: String,
      required: false,
      default: 'update',
      validator: value => Object.keys(ACTIONS).includes(value)
    },
    onConfirm: {
      type: Function,
      required: true
    }
  },
  methods: {
    async handleConfirm () {
      await this.onConfirm()
      this.$emit('close')
    }
  }
}
</script>
